<template>
    <ts-card>
        <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
            <h1 class="page-header">
                {{
                    $t(
                        'administration.employee.employeeDailyTimescan.employeeDailyTimescan'
                    )
                }}
            </h1>
            <ts-modal-close-button />
        </div>
        <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
                <form class="form-horizontal">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row form-group m-b-15">
                                <label class="col-md-3 col-form-label required">{{
                                    $t('administration.employee.employeeDailyTimescan.attendaceDate')
                                    }}</label>
                                <div class="col-md-8">
                                    <ts-date-picker-input v-model="model.att_date" :closeOnSelect="true" readonly>
                                    </ts-date-picker-input>
                                    <div class="validate" v-if="errors.has('att_date')">
                                        {{ errors.first('att_date') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row form-group m-b-15">
                                <label class="col-md-3 col-form-label required">{{
                                    $t('administration.employee.employeeDailyTimescan.employeeName')
                                    }}</label>
                                <div class="col-md-8">
                                    <input :value="editData.employee.name_en" class="form-control" readonly />
                                    <div class="validate" v-if="errors.has('staff_id')">
                                        {{ errors.first('staff_id') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row form-group m-b-15">
                                <label class="col-md-3 col-form-label required">{{
                                    $t('administration.employee.employeeDailyTimescan.checkIn')
                                    }}</label>
                                <div class="col-md-8">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <a-time-picker :value="model.check_in" format="HH:mm" valueFormat="HH:mm"
                                                @change="onChangeCheckIn" />
                                            <div class="validate" v-if="errors.has('check_in')">
                                                {{ errors.first('check_in') }}
                                            </div>
                                        </div>

                                        <div class="col-sm-8">
                                            <div class="row">
                                                <label class="col-md-5 col-form-label">{{
                                                    $t('administration.employee.employeeDailyTimescan.checkOut')
                                                    }}</label>
                                                <div class="col-md-7">
                                                    <a-time-picker @change="onChangeCheckOut" :value="model.check_out"
                                                        format="HH:mm" valueFormat="HH:mm" />
                                                    <div class="validate" v-if="errors.has('check_out')">
                                                        {{ errors.first('check_out') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row form-group mb-15">
                                <label class="col-md-3 col-form-label required">{{
                                    $t('administration.employee.employeeDailyTimescan.attStatus')
                                    }}</label>
                                <div class="col-md-8">
                                    <select v-model="model.att_status" style="width: 100%;" class="form-control">
                                        <option :value="null">{{ $t('select') }}</option>
                                        <option v-for="(att, index) in attStatus" :key="index" :value="att.value">
                                            {{ att.att_status }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row form-group m-b-15">
                                <label class="col-md-3 col-form-label required">{{
                                    $t('campusAttendance.remarks')
                                    }}</label>
                                <div class="col-md-8">
                                    <textarea v-model="model.att_description" class="form-control" rows="5"></textarea>
                                    <div class="validate" v-if="errors.has('att_description')">
                                        {{ errors.first('att_description') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 text-right">
                            <ts-button class="btn-default mr-2" @click.prevent="$emit('close')">{{ $t('cancel')
                            }}</ts-button>

                            <ts-button class="btn-primary" @click.prevent="update" :waiting="waiting">{{ $t('update')
                            }}</ts-button>
                        </div>
                    </div>
                </form>
            </ts-loading-banner>
        </ts-card-wrapper>
    </ts-card>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { method } from 'lodash';

export default {
    props: ['editData'],

    data() {
        return {
            loading: false,
            errors: new Errors(),
            saving: false,
            waiting: false,
            model: {
                check_in: null,
                check_out: null,
                att_status: null,
                att_description: null,
                att_date: null
            },
            attStatus: [
                {
                    value: 'Present',
                    att_status: 'Present'
                },
                {
                    value: 'Absent',
                    att_status: 'Absent'
                },
                {
                    value: 'Leave',
                    att_status: 'Leave'
                },
                {
                    value: 'DayOff',
                    att_status: 'Day Off'
                }
            ],
        }
    },
    created() {
        this.setEditData()
    },
    methods: {
        onChangeCheckIn(moment, check_in) {
            this.model.check_in = check_in
        },
        onChangeCheckOut(moment, check_out) {
            this.model.check_out = check_out
        },
        update() {
            this.errors = new Errors()
            this.waiting = true
            this.$store
                .dispatch('employeeDailyTimescan/store', this.model)
                .then(response => {
                    this.$toasted.success(response.message)
                    this.waiting = false
                    this.$emit('close')
                })
                .catch(error => {
                    this.waiting = false
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
        },
        setEditData() {
            this.model.check_in = this.editData.t1
            this.model.check_out = this.editData.t2
            this.model.att_description = this.editData.att_description
            this.model.att_status = this.editData.att_status
            this.model.att_date = this.editData.att_date
            this.model.staff_id = this.editData.staff_id

        },
    }
}
</script>